import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import validator from "validator";
import { useAuth } from "../hooks/useAuth";
import logo from '../../images/tiutLogo.png';

// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/navigation";

const studentImages = [
    "/images/students/jpeg-optimizer_DSC03384.JPG",
    "/images/students/jpeg-optimizer_DSC03387.JPG",
    "/images/students/jpeg-optimizer_DSC03397.JPG",
    "/images/students/jpeg-optimizer_DSC03481.JPG",
    "/images/students/jpeg-optimizer__D560051.JPG",
    "/images/students/jpeg-optimizer__D560069.JPG",
    "/images/students/jpeg-optimizer__D560115.JPG",
];

function Register() {
    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        role: "",
        password: "",
        confirmpassword: "",
        terms: "",
    });

    const [errors, setErrors] = useState({});
    const [loader, setLoader] = useState(false);
    const [step, setStep] = useState(1);
    const { login } = useAuth(); 
    const navigate = useNavigate();  

    const handleChange = (e) =>
        setForm({ ...form, [e.target.name]: e.target.value });

    const getErrorMessage = (err) => {
        if (!err) return null;
        if (Array.isArray(err)) return err[0];
        if (typeof err === "object") return Object.values(err)[0] || JSON.stringify(err);
        return String(err);
    };

    const validate = () => {
        let newErrors = {};
        if (validator.isEmpty(form.name || "")) newErrors.name = "Name is required";
        if (!validator.isEmail(form.email || "")) newErrors.email = "Valid email is required";
        if (!validator.isMobilePhone(form.phone || "", "any"))
            newErrors.phone = "Valid phone number is required";
        if (!form.role || validator.isEmpty(form.role))
            newErrors.role = "Please select your role";
        if (!validator.isLength(form.password || "", { min: 6 }))
            newErrors.password = "Password must be at least 6 characters";
        if (!validator.isStrongPassword(form.password || ""))
            newErrors.password =
                "Password must contain at least 1 uppercase, 1 lowercase, 1 number and 1 symbol";
        if (form.password !== form.confirmpassword)
            newErrors.confirmpassword = "Passwords do not match";
        if (form.terms !== "on")
            newErrors.terms = "You must accept terms and conditions";
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setErrors({});
        setLoader(true);

        fetch(`/api/register`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(form),
        })
            .then((response) => response.json())
            .then((data) => {
                setLoader(false);
                if (data.extraerror) {
                    setErrors(data.extraerror);
                } else if (data.errors) {
                    setErrors(data.errors);
                } else {
                    setStep(2);
                }
            })
            .catch((error) => {
                setLoader(false);
                setErrors({ general: "Network error occurred. Please check your connection and try again." });
                console.error("Registration Error:", error);
            });
    };

    // OTP validation logic
    const [otp, setOtp] = useState({
        otp: "",
    });
    const [otpErrors, setOtpErrors] = useState({});
    const [resending, setResending] = useState(false);
    const [resendMessage, setResendMessage] = useState("");

    const handleOTPChnage = (e) =>
        setOtp({ ...otp, [e.target.name]: e.target.value });

    const OtpValidator = () => {
        let newErrors = {};
        if (validator.isEmpty(otp.otp || "")) newErrors.otp = "OTP is required";
        return newErrors;
    };

    const handleOtp = (e) => {
        e.preventDefault();
        let newErrors = OtpValidator();
        setOtpErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
            return;
        }

        setOtpErrors({});
        setLoader(true);

        fetch(`/api/verify-otp`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                otp: otp.otp,
                email: form.email,
                password: form.password,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                setLoader(false);
                if (data.extraerror) {
                    setOtpErrors(typeof data.extraerror === "object" ? data.extraerror : { otp: data.extraerror });
                } else if (data.errors) {
                    setOtpErrors(data.errors);
                } else if (data.message && !data.access_token) {
                    setOtpErrors({ otp: data.message });
                } else if (data.access_token) {
                    login(data.access_token);
                    navigate("/");
                }
            })
            .catch((error) => {
                setLoader(false);
                setOtpErrors({ general: "Verification failed. Please check your connection and try again." });
                console.error("OTP Error:", error);
            });
    };

    const handleResendOtp = () => {
        setResending(true);
        setOtpErrors({});
        setResendMessage("");

        fetch(`/api/send-otp`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email: form.email }),
        })
            .then((response) => response.json())
            .then((data) => {
                setResending(false);
                if (data.message) {
                    setResendMessage("A new OTP has been sent to your email.");
                } else if (data.errors || data.extraerror) {
                    setOtpErrors(data.extraerror || data.errors);
                }
            })
            .catch((error) => {
                setResending(false);
                setOtpErrors({ general: "Failed to resend OTP. Please try again." });
                console.error("Resend OTP Error:", error);
            });
    };

    return (
        <div>
            <div className="nav-header postion-sticky top-0 bg-white shadow-none border-0">
                <div className="nav-top justify-content-between w-100">
                    <a href="/"><img src={logo} className="logo" alt="logo" style={{ width: "150px" }} /></a>
                    <Link
                        to="/login"
                        className="mob-menu ms-auto me-2 chat-active-btn text-grey-900 font-sm btn-round-md bg-greylight px-3 py-2"
                        style={{ height: "unset" }}
                    >
                        Login <i className="feather-log-in" />
                    </Link>

                    <Link
                        to="/login"
                        className="header-btn d-none d-lg-block bg-current fw-500 text-white font-xsss p-3 ms-2 w100 text-center lh-20 rounded-xl"
                    >
                        Login
                    </Link>
                </div>
            </div>

            <div className="row g-0">
                <div
                    className="col-xl-7 p-0 vh-100 position-relative overflow-hidden d-none d-xl-block"
                    style={{ backgroundColor: "#1a1a1a" }}
                >
                    <Swiper
                        modules={[Autoplay, EffectFade, Pagination, Navigation]}
                        effect="fade"
                        speed={1000}
                        autoplay={{
                            delay: 3500,
                            disableOnInteraction: false,
                        }}
                        pagination={{
                            clickable: true,
                            dynamicBullets: true,
                        }}
                        loop={true}
                        className="w-100 h-100 login-swiper"
                    >
                        {studentImages.map((src, index) => (
                            <SwiperSlide key={index} className="w-100 h-100 position-relative">
                                <img
                                    src={src}
                                    alt={`Student Alumni ${index + 1}`}
                                    className="w-100 h-100"
                                    style={{
                                        objectFit: "cover",
                                        objectPosition: "center top",
                                    }}
                                />
                                <div
                                    className="position-absolute bottom-0 start-0 w-100 p-4 text-start"
                                    style={{
                                        background: "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 60%, transparent 100%)",
                                        zIndex: 10,
                                    }}
                                >
                                    <span className="badge bg-danger text-white font-xssss px-3 py-1 rounded-pill mb-2">
                                        TIUT Alumni Community
                                    </span>
                                    <h3 className="text-white fw-700 font-lg mb-1">
                                        Empowering Futures, Connecting Generations
                                    </h3>
                                    <p className="text-white-50 font-xssss mb-3">
                                        Join hands with fellow graduates and explore endless networking opportunities.
                                    </p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>

                {step === 1 && (
                    <div className="col-xl-5 vh-100 align-items-center d-flex bg-white rounded-3 overflow-hidden">
                        <div className="card shadow-none border-0 ms-auto me-auto login-card">
                            <div className="card-body rounded-0 text-left">
                                <h2 className="fw-700 display1-size display2-md-size mb-4">
                                    Create <br />
                                    your account
                                </h2>

                                {errors.general && (
                                    <div className="form-alert-error">
                                        <i className="ti-alert font-sm"></i>
                                        <span>{getErrorMessage(errors.general)}</span>
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="form-group icon-input mb-3">
                                        <i className="font-sm ti-user text-grey-500 pe-0" />
                                        <input
                                            type="text"
                                            className={`style2-input ps-5 form-control text-grey-900 font-xsss fw-600 ${errors.name ? "input-error" : ""}`}
                                            name="name"
                                            value={form.name}
                                            placeholder="Your Name"
                                            onChange={handleChange}
                                            autoComplete="name"
                                        />
                                        {errors.name && (
                                            <p className="form-error-msg">
                                                <i className="ti-alert"></i> {getErrorMessage(errors.name)}
                                            </p>
                                        )}
                                    </div>

                                    <div className="form-group icon-input mb-3">
                                        <i className="font-sm ti-email text-grey-500 pe-0" />
                                        <input
                                            type="email"
                                            className={`style2-input ps-5 form-control text-grey-900 font-xsss fw-600 ${errors.email ? "input-error" : ""}`}
                                            placeholder="Your Email Address"
                                            name="email"
                                            value={form.email}
                                            onChange={handleChange}
                                            autoComplete="email"
                                        />
                                        {errors.email && (
                                            <p className="form-error-msg">
                                                <i className="ti-alert"></i> {getErrorMessage(errors.email)}
                                            </p>
                                        )}
                                    </div>

                                    <div className="form-group icon-input mb-3">
                                        <i className="font-sm ti-mobile text-grey-500 pe-0" />
                                        <input
                                            type="tel"
                                            className={`style2-input ps-5 form-control text-grey-900 font-xsss fw-600 ${errors.phone ? "input-error" : ""}`}
                                            placeholder="Phone Number"
                                            name="phone"
                                            value={form.phone}
                                            onChange={handleChange}
                                            autoComplete="tel"
                                        />
                                        {errors.phone && (
                                            <p className="form-error-msg">
                                                <i className="ti-alert"></i> {getErrorMessage(errors.phone)}
                                            </p>
                                        )}
                                    </div>

                                    <div className="form-group icon-input mb-3 position-relative">
                                        <i className="font-sm ti-id-badge text-grey-500 pe-0" style={{ zIndex: 2 }} />
                                        <select
                                            className={`style2-input ps-5 form-control font-xsss fw-600 ${errors.role ? "input-error" : ""}`}
                                            name="role"
                                            value={form.role}
                                            onChange={handleChange}
                                            style={{
                                                height: "60px",
                                                color: form.role ? "#212529" : "#adb5bd",
                                                cursor: "pointer",
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                                MozAppearance: "none",
                                                backgroundImage: "url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23adb5bd' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\")",
                                                backgroundRepeat: "no-repeat",
                                                backgroundPosition: "right 1.25rem center",
                                                backgroundSize: "14px 10px",
                                                paddingRight: "2.5rem",
                                                backgroundColor: "#fff",
                                            }}
                                        >
                                            <option value="" style={{ color: "#adb5bd" }}>Select Role</option>
                                            <option value="student" style={{ color: "#212529" }}>I am a Student</option>
                                            <option value="faculty" style={{ color: "#212529" }}>I am a Faculty</option>
                                        </select>
                                        {errors.role && (
                                            <p className="form-error-msg">
                                                <i className="ti-alert"></i> {getErrorMessage(errors.role)}
                                            </p>
                                        )}
                                    </div>

                                    <div className="form-group icon-input mb-3">
                                        <input
                                            type="password"
                                            className={`style2-input ps-5 form-control text-grey-900 font-xss ls-3 ${errors.password ? "input-error" : ""}`}
                                            placeholder="Password"
                                            name="password"
                                            value={form.password}
                                            onChange={handleChange}
                                            autoComplete="new-password"
                                        />
                                        <i className="font-sm ti-lock text-grey-500 pe-0" />
                                        {errors.password && (
                                            <p className="form-error-msg">
                                                <i className="ti-alert"></i> {getErrorMessage(errors.password)}
                                            </p>
                                        )}
                                    </div>

                                    <div className="form-group icon-input mb-1">
                                        <input
                                            type="password"
                                            className={`style2-input ps-5 form-control text-grey-900 font-xss ls-3 ${errors.confirmpassword ? "input-error" : ""}`}
                                            placeholder="Confirm Password"
                                            name="confirmpassword"
                                            value={form.confirmpassword}
                                            onChange={handleChange}
                                            autoComplete="new-password"
                                        />
                                        <i className="font-sm ti-lock text-grey-500 pe-0" />
                                        {errors.confirmpassword && (
                                            <p className="form-error-msg">
                                                <i className="ti-alert"></i> {getErrorMessage(errors.confirmpassword)}
                                            </p>
                                        )}
                                    </div>

                                    <div className="form-check text-left mb-3 mt-3">
                                        <input
                                            type="checkbox"
                                            className={`form-check-input mt-2 ${errors.terms ? "border-danger" : ""}`}
                                            id="exampleCheck2"
                                            name="terms"
                                            onChange={handleChange}
                                        />
                                        <label
                                            className="form-check-label font-xsss text-grey-500"
                                            htmlFor="exampleCheck2"
                                        >
                                            Accept Term and Conditions
                                        </label>
                                        {errors.terms && (
                                            <p className="form-error-msg">
                                                <i className="ti-alert"></i> {getErrorMessage(errors.terms)}
                                            </p>
                                        )}
                                    </div>

                                    <button
                                        type="submit"
                                        className="form-control text-center style2-input text-white fw-600 bg-dark border-0 p-0 d-flex align-items-center justify-content-center"
                                        style={{ height: "50px", cursor: loader ? "not-allowed" : "pointer", opacity: loader ? 0.85 : 1 }}
                                        disabled={loader}
                                    >
                                        {loader ? (
                                            <>
                                                <span className="btn-loader"></span>
                                                <span>Registering...</span>
                                            </>
                                        ) : (
                                            "Register"
                                        )}
                                    </button>
                                </form>

                                <div className="col-sm-12 p-0 text-left mt-3">
                                    <h6 className="text-grey-500 font-xsss fw-500 mt-0 mb-0 lh-32">
                                        Already have account?
                                        <Link to="/login" className="fw-700 ms-1">
                                            Login
                                        </Link>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {step === 2 && (
                    <div className="col-xl-5 vh-100 align-items-center d-flex bg-white rounded-3 overflow-hidden">
                        <div className="card shadow-none border-0 ms-auto me-auto login-card">
                            <div className="card-body rounded-0 text-left">
                                <h2 className="fw-700 display1-size display2-md-size mb-4">
                                    OTP <br />
                                    Verification
                                </h2>

                                {otpErrors.general && (
                                    <div className="form-alert-error">
                                        <i className="ti-alert font-sm"></i>
                                        <span>{getErrorMessage(otpErrors.general)}</span>
                                    </div>
                                )}

                                {resendMessage && (
                                    <div className="alert alert-success d-flex align-items-center font-xsss fw-600 mb-3" style={{ borderRadius: "8px" }}>
                                        <i className="ti-check me-2"></i> {resendMessage}
                                    </div>
                                )}

                                <form onSubmit={handleOtp}>
                                    <div className="form-group icon-input mb-3">
                                        <i className="font-sm ti-lock text-grey-500 pe-0" />
                                        <input
                                            type="text"
                                            className={`style2-input ps-5 form-control text-grey-900 font-xsss fw-600 ${otpErrors.otp ? "input-error" : ""}`}
                                            name="otp"
                                            value={otp.otp}
                                            placeholder="Enter 6-digit OTP"
                                            onChange={handleOTPChnage}
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            maxLength={6}
                                            autoComplete="one-time-code"
                                        />
                                        {otpErrors.otp && (
                                            <p className="form-error-msg">
                                                <i className="ti-alert"></i> {getErrorMessage(otpErrors.otp)}
                                            </p>
                                        )}
                                    </div>

                                    <div className="text-left mb-3">
                                        <label className="font-xsss text-grey-500">
                                            An OTP has been sent to your email <strong>{form.email}</strong>
                                        </label>
                                    </div>

                                    <button
                                        type="submit"
                                        className="form-control text-center style2-input text-white fw-600 bg-dark border-0 p-0 d-flex align-items-center justify-content-center"
                                        style={{ height: "50px", cursor: loader ? "not-allowed" : "pointer", opacity: loader ? 0.85 : 1 }}
                                        disabled={loader}
                                    >
                                        {loader ? (
                                            <>
                                                <span className="btn-loader"></span>
                                                <span>Verifying OTP...</span>
                                            </>
                                        ) : (
                                            "Verify"
                                        )}
                                    </button>
                                </form>

                                <div className="d-flex justify-content-between align-items-center mt-3 pt-2">
                                    <button
                                        type="button"
                                        className="btn btn-link p-0 text-grey-600 font-xsss fw-600 text-decoration-none"
                                        onClick={() => { setStep(1); setErrors({}); }}
                                    >
                                        <i className="ti-arrow-left me-1"></i> Back to Edit
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-link p-0 text-danger font-xsss fw-700 text-decoration-none"
                                        disabled={resending}
                                        onClick={handleResendOtp}
                                    >
                                        {resending ? "Resending..." : "Resend OTP"}
                                    </button>
                                </div>

                                <div className="col-sm-12 p-0 text-left mt-4 border-top pt-3">
                                    <h6 className="text-grey-500 font-xsss fw-500 mt-0 mb-0 lh-32">
                                        Already have account?
                                        <Link to="/login" className="fw-700 ms-1">
                                            Login
                                        </Link>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Register;
